/*
 * サブシステム名：マスタ管理
 * 機能名：発着地単価一覧 package版
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'

import header from '@/ddv2.library/header'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdTextBox = () => import('../../components/DdTextBox.vue')

export default {
  name: 'MstHacchakuchiTankaList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      tankahyoCd: '',
      hinmeiCd: '',
      hatsuchiCd: '',
      chakuchiCd: '',
      torihikisakiCd: '',
      eigyoshoCd: '',
      kingakuKoteiMode: true
    },
    headersHinmeiList: header.mstHinmeiHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headersHacchakuchiList: header.mstHacchakuchiHeaders,
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    filteredRows () {
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''

        // 距離範囲
        if (elem.kyoriFrom !== null && elem.kyoriFrom !== undefined) {
          elem.kyoriFromDisp = filter.numericFormatter(elem.kyoriFrom)
        } else {
          elem.kyoriFromDisp = ''
        }
        if (elem.kyoriTo !== null && elem.kyoriTo !== undefined) {
          elem.kyoriToDisp = filter.numericFormatter(elem.kyoriTo)
        } else {
          elem.kyoriToDisp = ''
        }
        // 数量範囲
        if (elem.suryoFrom !== null && elem.suryoFrom !== undefined) {
          elem.suryoFromDisp = filter.numericFormatter(elem.suryoFrom)
        } else {
          elem.suryoFromDisp = ''
        }
        if (elem.suryoTo !== null && elem.suryoTo !== undefined) {
          elem.suryoToDisp = filter.numericFormatter(elem.suryoTo)
        } else {
          elem.suryoToDisp = ''
        }
        // 重量範囲
        if (elem.juryoFrom !== null && elem.juryoFrom !== undefined) {
          elem.juryoFromDisp = filter.numericFormatter(elem.juryoFrom)
        } else {
          elem.juryoFromDisp = ''
        }
        if (elem.juryoTo !== null && elem.juryoTo !== undefined) {
          elem.juryoToDisp = filter.numericFormatter(elem.juryoTo)
        } else {
          elem.juryoToDisp = ''
        }
        // 運賃車両サイズ範囲
        if (elem.sharyoSizeFrom !== null && elem.sharyoSizeFrom !== undefined) {
          elem.sharyoSizeFromDisp = filter.numericFormatter(elem.sharyoSizeFrom)
        } else {
          elem.sharyoSizeFromDisp = ''
        }
        if (elem.sharyoSizeTo !== null && elem.sharyoSizeTo !== undefined) {
          elem.sharyoSizeToDisp = filter.numericFormatter(elem.sharyoSizeTo)
        } else {
          elem.sharyoSizeToDisp = ''
        }
        // 単価
        if (elem.tanka !== null && elem.tanka !== undefined) {
          elem.tankaDisp = filter.numericFormatter(elem.tanka)
        } else {
          elem.tankaDisp = ''
        }
        // 高速代（課税）
        if (elem.hiwayPrice !== null && elem.hiwayPrice !== undefined) {
          elem.hiwayPriceDisp = filter.numericFormatter(elem.hiwayPrice)
        } else {
          elem.hiwayPriceDisp = ''
        }
        // ユーザー金額1~10（課税）
        if (elem.userKingakuKazei1 !== null && elem.userKingakuKazei1 !== undefined) {
          elem.userKingakuKazei1Disp = filter.numericFormatter(elem.userKingakuKazei1)
        } else {
          elem.userKingakuKazei1Disp = ''
        }
        if (elem.userKingakuKazei2 !== null && elem.userKingakuKazei2 !== undefined) {
          elem.userKingakuKazei2Disp = filter.numericFormatter(elem.userKingakuKazei2)
        } else {
          elem.userKingakuKazei2Disp = ''
        }
        if (elem.userKingakuKazei3 !== null && elem.userKingakuKazei3 !== undefined) {
          elem.userKingakuKazei3Disp = filter.numericFormatter(elem.userKingakuKazei3)
        } else {
          elem.userKingakuKazei3Disp = ''
        }
        if (elem.userKingakuKazei4 !== null && elem.userKingakuKazei4 !== undefined) {
          elem.userKingakuKazei4Disp = filter.numericFormatter(elem.userKingakuKazei4)
        } else {
          elem.userKingakuKazei4Disp = ''
        }
        // ユーザー金額1~10（非課税）
        if (elem.userKingakuHikazei1 !== null && elem.userKingakuHikazei1 !== undefined) {
          elem.userKingakuHikazei1Disp = filter.numericFormatter(elem.userKingakuHikazei1)
        } else {
          elem.userKingakuHikazei1Disp = ''
        }
        if (elem.userKingakuHikazei2 !== null && elem.userKingakuHikazei2 !== undefined) {
          elem.userKingakuHikazei2Disp = filter.numericFormatter(elem.userKingakuHikazei2)
        } else {
          elem.userKingakuHikazei2Disp = ''
        }
        elem.tankaAmountDisp = filter.numericFormatter(parseInt(elem.tanka ?? 0, 10) +
            parseInt(elem.hiwayPrice ?? 0, 10) +
            parseInt(elem.userKingakuKazei1 ?? 0, 10) +
            parseInt(elem.userKingakuKazei2 ?? 0, 10) +
            parseInt(elem.userKingakuKazei3 ?? 0, 10) +
            parseInt(elem.userKingakuKazei4 ?? 0, 10) +
            parseInt(elem.userKingakuHikazei1 ?? 0, 10) +
            parseInt(elem.userKingakuHikazei2 ?? 0, 10))
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 品名リスト
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 取引先リスト
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地リスト
    filteredHacchakuchiList () {
      console.log('filteredhacchakuchiList')
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        console.log('filteredhacchakuchiList Mapping')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        console.log('filteredhacchakuchiList filter')
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions,
        searchText: this.searchText,
        rows: this.rows
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msthacchakuchi', 'msthinmei', 'msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            console.log('MstHacchakuchiTankaList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '単価表コード', value: 'tankahyoCd' },
              { text: '単価表種類区分', value: 'tankahyokbnNm' },
              { text: '単価表種類詳細区分', value: 'tankahyodetailkbnNm' },
              { text: '金額合計(目安)', value: 'tankaAmountDisp', align: 'end' },
              { text: '取引先名称', value: 'torihikisakiNm' },
              { text: '営業所名称', value: 'eigyoshoNm' },
              { text: '発地', value: 'hatsuchiNm' },
              { text: '着地', value: 'chakuchiNm' },
              { text: '品名', value: 'hinmeiNm' },
              { text: '単価', value: 'tankaDisp', align: 'end' },
              { text: '運賃計算方法区分', value: 'unchinKeisanKbnNm', align: 'center' },
              // 固定金額
              { text: '運賃(高速)', value: 'hiwayPriceDisp', align: 'end' },
              { text: '運賃(他)', value: 'userKingakuKazei1Disp', align: 'end' },
              { text: '保管料', value: 'userKingakuKazei4Disp', align: 'end' },
              { text: '荷役料', value: 'userKingakuKazei3Disp', align: 'end' },
              { text: '運賃他(非)', value: 'userKingakuHikazei1Disp', align: 'end' },
              { text: '立替金(非)', value: 'userKingakuHikazei2Disp', align: 'end' },
              { text: '割増その他', value: 'userKingakuKazei2Disp', align: 'end' },
              { text: '運賃車種種別', value: 'unchinShashuSbtNm' },
              { text: '荷姿種別', value: 'nisugataSbtNm' },
              // 追加条件
              { text: '距離(Km)_From', value: 'kyoriFromDisp', align: 'end' },
              { text: '距離(Km)_To', value: 'kyoriToDisp', align: 'end' },
              { text: '数量_From', value: 'suryoFromDisp', align: 'end' },
              { text: '数量_To', value: 'suryoToDisp', align: 'end' },
              { text: '重量_From', value: 'juryoFromDisp', align: 'end' },
              { text: '重量_To', value: 'juryoToDisp', align: 'end' },
              { text: '運賃車両サイズ_From', value: 'sharyoSizeFromDisp', align: 'end' },
              { text: '運賃車両サイズ_To', value: 'sharyoSizeToDisp', align: 'end' },
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('initializeInputPromise')
            self.conditions = {
              tankahyoCd: '',
              hinmeiCd: '',
              hatsuchiCd: '',
              chakuchiCd: '',
              torihikisakiCd: '',
              eigyoshoCd: self.eigyoshoReadOnly ? self.userEigyoshoCd : '',
              kingakuKoteiMode: true
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstThacchakuchiTankaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstThacchakuchiTankaList.savedInputRestorePromise after loadFromCache', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstThacchakuchiTankaList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstThacchakuchiTankaList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCMstHacchakuchiTanka/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              tankahyoCd: '',
              hinmeiCd: '',
              hatsuchiCd: '',
              chakuchiCd: '',
              torihikisakiCd: '',
              eigyoshoCd: self.eigyoshoReadOnly ? self.userEigyoshoCd : '',
              kingakuKoteiMode: true
            }
            self.searchText = ''
            self.rows = []
            self.selected = []
            self.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log('onCreateButtonClick 0', e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
